import { render, staticRenderFns } from "./GroupMemberBar.vue?vue&type=template&id=1d38d49c&scoped=true"
import script from "./GroupMemberBar.vue?vue&type=script&lang=js"
export * from "./GroupMemberBar.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberBar.vue?vue&type=style&index=0&id=1d38d49c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38d49c",
  null
  
)

export default component.exports